import { render, staticRenderFns } from "./DashTreatingList.vue?vue&type=template&id=2396b1c5&scoped=true&"
import script from "./DashTreatingList.vue?vue&type=script&lang=js&"
export * from "./DashTreatingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396b1c5",
  null
  
)

export default component.exports